import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import React, { useState } from "react";
export default function useInvoiceModalInit() {
    var _useState = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 360,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalConfirmCancel = _useState[0], setModalConfirmCancel = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState1[0], setModalSuccess = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "savesuccess2"
    }), 2), modalSaveSuccess = _useState2[0], setModalSaveSuccess = _useState2[1];
    var _useState3 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalNotApprove = _useState3[0], setModalNotApprove = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 310,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState4[0], setModalAlert = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 480,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "inv-submitted"
    }), 2), modalSubmitted = _useState5[0], setModalSubmitted = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1345,
        height: 800,
        pin: false,
        mode: "normal",
        modalname: "inv-payment",
        paymentIndex: null,
        shouldInitForm: true,
        modeInv: "create"
    }), 2), modalInvPayment = _useState6[0], setModalInvPayment = _useState6[1];
    return {
        modalConfirmCancel: modalConfirmCancel,
        setModalConfirmCancel: setModalConfirmCancel,
        modalSuccess: modalSuccess,
        setModalSuccess: setModalSuccess,
        modalSaveSuccess: modalSaveSuccess,
        setModalSaveSuccess: setModalSaveSuccess,
        modalNotApprove: modalNotApprove,
        setModalNotApprove: setModalNotApprove,
        modalAlert: modalAlert,
        setModalAlert: setModalAlert,
        modalSubmitted: modalSubmitted,
        setModalSubmitted: setModalSubmitted,
        modalInvPayment: modalInvPayment,
        setModalInvPayment: setModalInvPayment
    };
}
